<div class="viz-binning-settings-modal">
  <div class="binning-modal-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <mode-dialog-header>
      <h1 heading>Bin settings</h1>
      <div sub-heading class="sub-header">
        <span class="sub-header-field">Field:</span>{{ targetField.isBinned ? targetField.displayFormula : targetField.displayName }}
      </div>
    </mode-dialog-header>
  </div>
  <div class="content-container">
    <div>
      <ng-container *ngIf="isLoading$ | async; then loader; else binSettings"></ng-container>
    </div>
    <ng-template #loader>
      <mode-loader class="loader" [class.visible]="showLoader$ | async" type="secondaryGreen"></mode-loader>
    </ng-template>
    <ng-template #binSettings>
      <div>
        <p class="description">
          Binned fields have a fixed bin size once created. Recalculate bin size by entering a new number or clicking the recommended bin size button below.
        </p>
        <h3 class="input-title">Fixed bin size</h3>
        <div class="input-container">
          <input
            type="number"
            min="0"
            [value]="this.currentBinSizeVal"
            (input)="onBinSizeInputChange($event.target.value)"
            [class.error] = "errorMessage"
          />
          <button (click)="onClickUseRecommended()" [disabled]="this.currentBinSizeVal === this.suggestedBinSize && enableUseRecommended">Use recommended</button>
        </div>
        <div style="display: flex; flex-direction: row; align-items: center;">
          <div class="error-message">
            <span *ngIf="errorMessage">
              {{ errorMessage }}
            </span>
          </div>
          <div *ngIf="suggestedBinSize" class="recommended-binsize">Recommended bin size: <span>{{suggestedBinSize}}</span></div>
        </div>
      </div>
    </ng-template>
    <div class="action-buttons">
      <div class="right-actions">
        <capra-button
          data-test="binning-modal-apply-button"
          text="Apply"
          variant="secondary"
          color="neutral"
          (clicked)="doApply(false)"
        ></capra-button>
        <capra-button
          data-test="binning-modal-apply-and-close-button"
          text="Apply & close"
          color="default"
          (clicked)="doApply(true)"
        ></capra-button>
      </div>
    </div>
  </div>
</div>
